const Title = ({
  mainTitleText,
  isMainTitle,
  subTitle,
  description,
  mainTitleClass,
  subTitleClass,
  descriptionClass,
}) => (
  <>
    {isMainTitle ? (
      <h1 className={mainTitleClass}>
        <span>{mainTitleText}</span>
      </h1>
    ) : (
      <h2 className={subTitleClass}>
        <span>{subTitle}</span>
      </h2>
    )}
    {description && (
      <p className={descriptionClass}>
        <span dangerouslySetInnerHTML={{ __html: description }}></span>
      </p>
    )}
  </>
);

export default Title;
